import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { posts } from "@/blog/posts";
import { ArrowRight } from "lucide-react";

const BlogPage = () => {
  const { lang } = useApp();
  const title = { fr: "Guides Pension Luxembourg", en: "Luxembourg Pension Guides", de: "Luxemburg Renten-Leitfäden" }[lang];
  const desc = {
    fr: "Articles et guides pour comprendre la pension au Luxembourg : CNAP, classes d'impôt, frontaliers.",
    en: "Articles to understand the Luxembourg pension system: CNAP formula, tax classes, cross-border workers.",
    de: "Artikel zum Luxemburger Rentensystem: CNAP-Formel, Steuerklassen, Grenzgänger.",
  }[lang];

  return (
    <section className="max-w-4xl mx-auto px-6 md:px-8 py-16" data-testid="blog-index">
      <SEO title={title} description={desc} path="/blog" />
      <div className="border-b border-slate-200 pb-6 mb-10">
        <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500">/ guides</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-slate-900 mt-2">{title}</h1>
      </div>
      <div className="space-y-2">
        {posts.map((p) => {
          const loc = p[lang] || p.fr;
          return (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-post-${p.slug}`}
              className="block border border-slate-200 bg-white p-6 md:p-8 hover:bg-slate-50 transition-colors group">
              <div className="text-[10px] font-mono uppercase tracking-widest text-slate-400">{p.date}</div>
              <h2 className="font-serif text-2xl text-slate-900 mt-2 group-hover:text-blue-700 transition-colors">{loc.title}</h2>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{loc.excerpt}</p>
              <div className="text-xs font-mono uppercase tracking-[0.15em] text-blue-700 mt-4 inline-flex items-center gap-2">
                {lang === "fr" ? "Lire" : lang === "de" ? "Lesen" : "Read"} <ArrowRight size={12} strokeWidth={1.5} />
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default BlogPage;
